
  import SectionMenuEntry from '@/components/SectionMenuEntry.vue';

  export default {
    props: ["menuEntries"],
    components: {
      SectionMenuEntry,
    }
  }
